"use strict";

var __makeTemplateObject = this && this.__makeTemplateObject || function (cooked, raw) {
  if (Object.defineProperty) {
    Object.defineProperty(cooked, "raw", {
      value: raw
    });
  } else {
    cooked.raw = raw;
  }

  return cooked;
};

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

exports.__esModule = true;

var em_1 = __importDefault(require("polished/lib/helpers/em"));

var styled_components_1 = __importDefault(require("styled-components"));

exports.Dots = styled_components_1["default"].ul(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  && {\n    position: static;\n    text-align: center;\n  }\n  & > li {\n    text-align: center;\n    vertical-align: middle;\n    margin: 0;\n\n    &.slick-active {\n      div:before {\n        background: ", ";\n        width: ", ";\n        height: ", ";\n      }\n    }\n  }\n"], ["\n  && {\n    position: static;\n    text-align: center;\n  }\n  & > li {\n    text-align: center;\n    vertical-align: middle;\n    margin: 0;\n\n    &.slick-active {\n      div:before {\n        background: ", ";\n        width: ", ";\n        height: ", ";\n      }\n    }\n  }\n"])), function (_a) {
  var theme = _a.theme;
  return theme.color.primary;
}, em_1["default"](12), em_1["default"](12));
exports.Dot = styled_components_1["default"].div(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n  margin: 0 ", ";\n  height: 100%;\n  width: 100%;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n\n  &:before {\n    content: '';\n    display: block;\n    background: #dbdbdb;\n    border-radius: 50%;\n    width: ", ";\n    height: ", ";\n    transition-property: background-color, width, height;\n    transition-duration: 0.3s;\n    transition-timing-function: ease;\n  }\n"], ["\n  margin: 0 ", ";\n  height: 100%;\n  width: 100%;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n\n  &:before {\n    content: '';\n    display: block;\n    background: #dbdbdb;\n    border-radius: 50%;\n    width: ", ";\n    height: ", ";\n    transition-property: background-color, width, height;\n    transition-duration: 0.3s;\n    transition-timing-function: ease;\n  }\n"])), em_1["default"](3), em_1["default"](8), em_1["default"](8));
var templateObject_1, templateObject_2;